export default __webpack_public_path__ + "static/media/github.69ffd9cd.png";